import React from 'react'
import AddPatientLayout from 'presentation/hospital/layouts/AddPatient'

export const AddPatient = () => {
  return <AddPatientLayout />
}
